import React, { useEffect, useState } from "react";
import { KeyBlock } from "components/key/KeyBlock";
import PropTypes from "prop-types";
import { Position } from "@blueprintjs/core";
import './EmployeeCircleStatus.css';
import './Status.css';
import './StatusPanel.css';

const defaultArray = [];

export function AssetStatus(
    {
        statusId = 0,
        ownershipId = 0,
        isLoading = false,
        statusAttributeMappings = defaultArray,
        ownershipAttributeMappings = defaultArray,
        tooltipPosition = Position.TOP,
        tooltip = null
    }
) {
    const [tooltipText, setTooltipText] = useState("");
    const [statusColour, setStatusColour] = useState("FF7454");
    const [ownershipClassName, setOwnershipClassName] = useState("");
    const [ownershipIcon, setOwnershipIcon] = useState("");

    useEffect(() => {
        if (statusId && ownershipId && statusAttributeMappings && ownershipAttributeMappings && statusAttributeMappings.length > 0 && ownershipAttributeMappings.length > 0) {
            let statusAttribute = statusAttributeMappings.find(o => {
                return o.id === statusId
            });

            let ownershipAttributes = ownershipAttributeMappings.find(o => {
                return o.id === ownershipId
            });

            if (statusAttribute) {
                setStatusColour(statusAttribute.colours);
            }

            if (ownershipAttributes) {
                setOwnershipClassName(ownershipAttributes.className);
                setOwnershipIcon(ownershipAttributes.icon);
            }

            if (tooltip == null) {
                setTooltipText(`${statusAttribute.name} ${ownershipAttributes.name}`);
            }
            else {
                setTooltipText(tooltip);
            }
        }
    }, [statusId, ownershipId, statusAttributeMappings, ownershipAttributeMappings, tooltip]);

    return (
        <div className="no-margin">
            <KeyBlock rounded={true} icon={ownershipIcon} className={ownershipClassName} colours={statusColour} size={8} loading={isLoading} toolTipText={tooltipText} tooltipPosition={tooltipPosition} />
        </div>
    );
}

AssetStatus.propTypes = {
    statusId: PropTypes.number,
    ownershipId: PropTypes.number,
    isLoading: PropTypes.bool,
    statusAttributeMappings: PropTypes.array,
    ownershipAttributeMappings: PropTypes.array,
    tooltipPosition: PropTypes.string,
    tooltip: PropTypes.string
};